import type { ReactNode } from 'react';

/**
 * Les deux états non-nominaux d'une ressource d'API, rendus de la même façon
 * partout dans la console : un chargement discret, une erreur en `role="alert"`.
 *
 * Une erreur de chargement n'est jamais silencieuse et ne se déguise jamais en
 * état vide : « aucun élève » et « la liste n'a pas pu être chargée » sont deux
 * phrases différentes, et les confondre fait prendre une panne pour un fait.
 */
export function Chargement({ quoi }: { quoi: string }) {
  return <p className="note-line">Chargement — {quoi}…</p>;
}

export function ErreurRessource({ message }: { message: string }) {
  return (
    <div className="callout callout--rare" role="alert">
      <strong>Chargement impossible.</strong> {message}
    </div>
  );
}

/**
 * Ce qu'un écran dit quand une dépendance serveur n'existe pas encore. On le
 * déclare, on ne le simule pas : une fonction absente sans explication se lit
 * comme un bogue, et une fonction simulée se lit comme une donnée.
 */
export function NonBranche({ titre, children }: { titre: string; children: ReactNode }) {
  return (
    <div className="card card--calm">
      <h3>{titre}</h3>
      <p className="note-line">{children}</p>
    </div>
  );
}
